import type { IconProps } from './types';

export const Search = ({ size, ...props }: IconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.1794 18.2161C5.47103 18.2161 1.6377 14.3828 1.6377 9.67448C1.6377 4.96615 5.47103 1.13281 10.1794 1.13281C14.8877 1.13281 18.721 4.96615 18.721 9.67448C18.721 14.3828 14.8877 18.2161 10.1794 18.2161ZM10.1794 2.38281C6.15436 2.38281 2.8877 5.65781 2.8877 9.67448C2.8877 13.6911 6.15436 16.9661 10.1794 16.9661C14.2044 16.9661 17.471 13.6911 17.471 9.67448C17.471 5.65781 14.2044 2.38281 10.1794 2.38281Z"
        fill="currentColor"
      />
      <path
        d="M18.9283 19.0552C18.7699 19.0552 18.6116 18.9969 18.4866 18.8719L16.8199 17.2052C16.5783 16.9635 16.5783 16.5635 16.8199 16.3219C17.0616 16.0802 17.4616 16.0802 17.7033 16.3219L19.3699 17.9885C19.6116 18.2302 19.6116 18.6302 19.3699 18.8719C19.2449 18.9969 19.0866 19.0552 18.9283 19.0552Z"
        fill="currentColor"
      />
    </svg>
  );
};
